import { Controller } from 'react-hook-form'
import BottomSheetSelect from 'Components/BottomSheetSelect/BottomSheetSelect'

const FDMBottomSheetSelectInput = (props: any) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={props?.rules}
      render={({ field: { onChange, value }, fieldState: { error }, formState }) => {
        return (
          <BottomSheetSelect
            onChange={onChange}
            value={value}
            {...props}
            onInputChange={props.onInputChange}
            options={props.options}
          />
        )
      }}
    />
  )
}

export default FDMBottomSheetSelectInput
